<template>
  <div class="clm-form-question">
    {{ text }} <span class="orange" @click="$emit('action')">{{ btnText }}</span>
  </div>
</template>

<script>
export default {
  name: "a-line-text",
  props: {
    lineType: {
      type: String,
      default: 'create'
    }
  },
  computed: {
    text() {
      if (this.lineType === 'create') {
        return this.$t('a-line-text.dontHaveAccount')
      } else {
        return this.$t('a-line-text.haveAccount')
      }
    },
    btnText() {
      if (this.lineType === 'create') {
        return this.$t('a-line-text.createAccount')
      } else {
        return this.$t('a-line-text.loginAccount')
      }
    }
  }
}
</script>
